__turbopack_context__.v({
  "avatar": "CustomerReviews-module__2hhCaq__avatar",
  "badge": "CustomerReviews-module__2hhCaq__badge",
  "badgeText": "CustomerReviews-module__2hhCaq__badgeText",
  "card": "CustomerReviews-module__2hhCaq__card",
  "cardGrid": "CustomerReviews-module__2hhCaq__cardGrid",
  "cardGridText": "CustomerReviews-module__2hhCaq__cardGridText",
  "divider": "CustomerReviews-module__2hhCaq__divider",
  "header": "CustomerReviews-module__2hhCaq__header",
  "headingBlock": "CustomerReviews-module__2hhCaq__headingBlock",
  "marquee": "CustomerReviews-module__2hhCaq__marquee",
  "meta": "CustomerReviews-module__2hhCaq__meta",
  "name": "CustomerReviews-module__2hhCaq__name",
  "scrollReviews": "CustomerReviews-module__2hhCaq__scrollReviews",
  "section": "CustomerReviews-module__2hhCaq__section",
  "set": "CustomerReviews-module__2hhCaq__set",
  "stars": "CustomerReviews-module__2hhCaq__stars",
  "text": "CustomerReviews-module__2hhCaq__text",
  "time": "CustomerReviews-module__2hhCaq__time",
  "track": "CustomerReviews-module__2hhCaq__track",
  "user": "CustomerReviews-module__2hhCaq__user",
  "userInfo": "CustomerReviews-module__2hhCaq__userInfo",
  "viewAllBtn": "CustomerReviews-module__2hhCaq__viewAllBtn",
  "writeBtn": "CustomerReviews-module__2hhCaq__writeBtn",
  "writeBtnMobile": "CustomerReviews-module__2hhCaq__writeBtnMobile",
});
